/**
 * Fetch the User permission token appsync query
 */
export const getPermissionToken = `
 query getPermissionToken {
    getPermissionToken(emailId: "@emailId", keyAccountId: "@keyAccountId")
 }
`;

/**
 * get Product Category micro apps 
 */
export const QueryProductCategory = `query getProductCategoryMicroappDetails{
   getProductCategoryMicroappDetails{
     productCategoryId
     microapps
   }
 }`;

export const getList = /* GraphQL */ `
  query getList($module: Modules!, $keyAccountId: String!) {
    getList(module: $module, keyAccountId: $keyAccountId)
  }
`;
export const getModule = /* GraphQL */ `
  query get($module: Modules!, $keyAccountId: String!, $idx: String!) {
    get(module: $module, keyAccountId: $keyAccountId, idx: $idx)
  }
`;
